import {Stars} from "react-bootstrap-icons"
import Typography from "./Typography/Typography"
import Button from "./components/Button"
import React, {useContext, useEffect, useRef, useState} from "react"
import {clarityEvents, gaCategories, gaEvents} from "../../config/googleAnalytics/events"
import {useRouter} from "next/router"
import AnalyticsContext from "../../context/AnalyticsContext"
import {useTranslation} from "next-i18next"
import CheckoutContext from "../../context/CheckoutContext"
import {storeDataToSpreadsheet} from "../../utility/Helper"

function SmartFilters({planLength}:{planLength:number}) {
	const {reactGA} = useContext(AnalyticsContext)
	const {setData} = useContext(CheckoutContext)
	const [input, setInput] = useState("")
	const [loading, setLoading] = useState(false)
	const {t} = useTranslation()
	const [result, setResult] = useState("")
	const textArea = useRef(null)
	const router = useRouter()
	const getSmartFilters = async (e, text) => {
		e.preventDefault()
		setLoading(true)

		if (typeof window !== "undefined") {
			window.clarity("set", clarityEvents.askedAi, "User Asked PDP AI")
		}

		reactGA?.event({
			category: gaCategories.pdp,
			action: `${gaEvents.askedPdpAi} ${input}`,
			label: `${gaEvents.askedPdpAi} ${input}`,
			nonInteraction: false
		})

		const updatedMessages = text ? text : input

		try {
			const res = await fetch(`/api/ai/mbp-ai-smart-filters?locale=${router.locale || "de"}`, {
				method: "POST",
				headers: {
					"Content-Type": "application/json"
				},
				body: JSON.stringify({
					description: updatedMessages,
					planLength
				})
			})

			const data = await res.json()

			if (data?.planLength) {
				setData(prev => ({...prev, planLength: data?.planLength || planLength}))
			}

			setResult(() => data.response)

			await storeDataToSpreadsheet({
				question: `${updatedMessages}`,
				answer: data.response
			}, "smartFiltersAi")

			reactGA?.event({
				category: gaCategories.pdp,
				action: `${gaEvents.AiAnswer} ${data.response} To the question ${input}`,
				label: `${gaEvents.AiAnswer} ${data.response} To the question ${input}`,
				nonInteraction: false
			})
		} catch (error) {
			console.error("Error communicating with the API:", error)
		}

		setLoading(false)
	}

	useEffect(() => {
		if (result?.includes("/alle-modelle-e-bike-schweiz?")) {
			router.push(result)
		}
	}, [result])
	return (
		<>
			<div className="d-flex my-2 align-items-center gap-1 justify-content-start">
				<div className="d-flex align-items-center justify-content-start gap-1">
					<Typography variant="bodySmBold">
						{t("smart-filters")}
					</Typography>
					<Typography variant="bodyXSm">
						{"(BETA 🤓)"}
					</Typography>
				</div>
			</div>
			<form className="send-message p-1 m-auto"
				onSubmit={e => getSmartFilters(e, input)}>
				<textarea
					ref={textArea}
					style={{fontSize: "14px"}}
					className="input-field p-2"
					value={input}
					rows={3}
					onChange={e => setInput(e.target.value)}
					placeholder={t("what-you-looking-for")}
					required />

			</form>
			<Button onClick={e => getSmartFilters(e, input)}
				type="submit"
				isLoading={loading}
				className="try-ai mt-3 col-12 "
				textColor="#fff"
				btnFontSize={11}
				label={t("apply-ai-filters")}
				spinnerColor="#fff"
				icon={<Stars color="#fff"
					size={20}
				/>}/></>
	)
}

export default SmartFilters
